import { ArrowClockwiseIcon as PhosphorArrowClockwiseIcon } from "@phosphor-icons/react/dist/ssr/ArrowClockwise";

import { createAppIcon } from "@/components/createAppIcon";

export const RefreshIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowClockwiseIcon);
